import { render, staticRenderFns } from "./RmaHistory.vue?vue&type=template&id=10dba091&scoped=true"
import script from "./RmaHistory.vue?vue&type=script&lang=js"
export * from "./RmaHistory.vue?vue&type=script&lang=js"
import style0 from "./RmaHistory.vue?vue&type=style&index=0&id=10dba091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dba091",
  null
  
)

export default component.exports